import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
export var formatMiliseconds = function formatMiliseconds(milliseconds) {
  var day = null;
  var hour = null;
  var minute = null;
  var seconds = null;
  seconds = Math.floor(milliseconds / 1000);
  minute = Math.floor(seconds / 60);
  seconds %= 60; // seconds = seconds % 60

  hour = Math.floor(minute / 60);
  minute %= 60; // minute = minute % 60

  day = Math.floor(hour / 24);
  hour %= 24; // hour = hour % 24

  var obj = {
    d: day,
    // day: day
    h: hour,
    m: minute,
    s: seconds
  };
  var date = [];

  _Object$keys(obj).forEach(function (key) {
    if (obj[key] > 0) {
      date.push(obj[key] + key);
    }
  });

  return date.join(' ');
};
export default {};